<template>
  <Hero />
  <About />
  <Service />
  <Worker />
  <Banner />
  <Inquiries />
</template>

<script lang="ts" setup>
import { onMounted, defineAsyncComponent } from "vue";
import { useHomeStore } from "@/stores/home";
const Worker = defineAsyncComponent(() => import("./partial/countries.vue"));
const Service = defineAsyncComponent(() => import("./partial/service.vue"));
const Inquiries = defineAsyncComponent(() => import("./partial/inquiries.vue"));
const About = defineAsyncComponent(() => import("./partial/about.vue"));
const Hero = defineAsyncComponent(() => import("./partial/hero.vue"));
const Banner = defineAsyncComponent(() => import("./partial/banner.vue"));

const homeStore = useHomeStore();
onMounted(() => {
  homeStore.getHome();
});
</script>
